export function normalizePersistedAccumulatorMs(
  value: number | null | undefined,
): number {
  const safe = Number(value ?? 0);
  if (!Number.isFinite(safe) || safe <= 0) return 0;

  // Backward compatibility: some persisted rows store seconds instead of ms.
  if (safe < 1000) return safe * 1000;

  return safe;
}
